var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React, { memo } from 'react';
import { Wrapper } from './BlockSection.Styles';
import { styled } from '@web/theme';
import chroma from 'chroma-js';
import { uuid } from '@web/utils';
import { useFirebase } from '@web/firebase';
import { usePage, usePageEdit } from '../../../ModulePage';
import { Button } from '../../../Button';
import { useBlockSection } from '../';
export var BlockSectionControls = memo(function (_a) {
    var index = _a.index;
    var _b = useBlockSection(), isColumn = _b.isColumn, blockSectionId = _b.blockSectionId;
    var _c = useFirebase(), addOrUpdateBlock = _c.addOrUpdateBlock, addOrUpdatePage = _c.addOrUpdatePage;
    var data = usePage().page.data;
    var pageInEditMode = usePageEdit().pageInEditMode;
    var onAdd = function () {
        var _a;
        var _id = uuid();
        var blockIndex = index === undefined ? 0 : index + 1;
        var blockSection = data.blocks[blockSectionId];
        blockSection.splice(blockIndex, 0, _id);
        addOrUpdateBlock({ _id: _id, data: { _id: _id, _title: 'Nový blok', _type: "", shadow: true, margin: true, text: '' } });
        addOrUpdatePage({ _id: data.id, data: { blocks: __assign(__assign({}, data.blocks), (_a = {}, _a[blockSectionId] = blockSection, _a)) } });
    };
    if (!pageInEditMode)
        return null;
    return (React.createElement(Wrapper, { style: { width: isColumn ? '100%' : 'auto' } },
        React.createElement(AddButton, { onClick: onAdd, icon: "plus" })));
});
var AddButton = styled(Button)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n\tcolor: ", ";\n\tbackground-color: transparent;\n\t\n\t&:hover {\n\t\tcolor: ", ";\n\t\tbackground-color: ", ";\n\t}\n"], ["\n\tcolor: ", ";\n\tbackground-color: transparent;\n\t\n\t&:hover {\n\t\tcolor: ", ";\n\t\tbackground-color: ", ";\n\t}\n"])), function (_a) {
    var theme = _a.theme;
    return chroma(theme.button.txt).alpha(.4).hex();
}, function (_a) {
    var theme = _a.theme;
    return chroma(theme.button.txt).darken(.3).hex();
}, function (_a) {
    var theme = _a.theme;
    return chroma(theme.button.bg).darken(.1).hex();
});
var templateObject_1;
